import React from 'react';
import { isBrowser, isMobile } from 'react-device-detect';
import PropTypes from 'prop-types';

const MainLayout = ({ children = null }) => (
  <div className="d-flex flex-row h-100 main-layout">
    <div
      className="d-flex flex-row flex-fill h-100 justify-content-center"
      style={{ overflowY: 'auto' }}>
      <div
        className={`w-100 position-relative ${isMobile ? 'px-3' : ''}`}
        style={{
          marginTop: isBrowser ? '6rem' : '2rem',
          maxWidth: '33.5rem',
          transitionProperty: 'margin',
          transitionDuration: '300ms',
        }}>
        {children}
      </div>
    </div>
  </div>
);

export default MainLayout;

MainLayout.propTypes = {
  children: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
};
